import { render, staticRenderFns } from "./ThreePanelPage.vue?vue&type=template&id=a7082ba4&scoped=true&"
import script from "./ThreePanelPage.vue?vue&type=script&lang=js&"
export * from "./ThreePanelPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7082ba4",
  null
  
)

export default component.exports